<template>
  <div
    class="card-main"
    @click="onClick"
    @mouseover="focusOn"
    @mouseleave="focusOut"
  >
    <div class="focus-ring" v-show="isfocusOn && mouseActivated"></div>
    <img
      v-if="cardData.highlightVod.count > 0"
      class="cover-img"
      v-lazy="cardData.highlightVod.list[0].imgUrl"
    />
    <img
      v-else-if="cardData.replayVod.count > 0"
      class="cover-img"
      v-lazy="cardData.replayVod.list[0].imgUrl"
    />
    <img
      v-else
      class="cover-img"
      v-lazy="cardData.vods.list[0].imgUrl"
    />
    <!-- <img class="cover-img" :src="cardData.vods.list[0].imgUrl" /> -->
    <div class="card-text">
      <template v-if="cardData.gameDesc.homeName">
        <p class="team-name singleline">{{ cardData.gameDesc.homeName }}</p>
        <p class="team-name singleline">{{ cardData.gameDesc.awayName }}</p>
      </template>
      <p v-else class="team-name singleline">{{ cardData.gameDesc.title }}</p>
      <p class="date">
        {{ roundAndDate }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveVue: true,
      isfocusOn: false,
    };
  },
  props: ["cardData", "isFocusedLine"],

  computed: {
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
    roundAndDate() {
      let str = this.dateFormat(this.cardData.gameDesc.beginDate);
      if (this.cardData.gameDesc.typeId == 2) {
        str = this.cardData.gameDesc.roundName + " | " + str;
      }
      return str;
    },
  },

  methods: {
    onClick() {
      if (this.isfocusOn) {
        this.clickCard();
      }
    },
    clickCard() {
      this.$router.push({
        name: "game-detail",
        params: {
          gameId: this.cardData.gameDesc.id,
          // vodType: this.cardData.gameDesc.type,
          t: new Date().getTime(),
        },
      });
      this.focusOut();
    },
    focusOn() {
      if (this.isFocusedLine) {
        this.isfocusOn = true;
      }
    },
    focusOut() {
      this.isfocusOn = false;
    },
    dateFormat(dateStr) {
      return dateStr.replace(/-/gi, ".").substr(0, 10);
    },
  },
};
</script>

<style scoped>
.card-main {
  position: relative;
  display: inline-block;
  margin-right: 20px;
  height: 320px;
}
.focus-ring {
  position: absolute;
  left: -5px;
  top: -4px;
  width: 366px;
  height: 320px;
  border: solid 4px #eeeeee;
  z-index: 5;
}
.card-text {
  padding: 12px 10px;
  display: inline-block;
  position: absolute;
  top: 206px;
  left: 0;
}
.cover-img {
  width: 366px;
  height: 206px;
  background-color: #2b2b2b;
}
.team-name {
  width: 347px;
  font-size: 28px;
  line-height: 34px;
  font-size: 24px;
  color: #a0a0a0;
}
.date {
  font-size: 18px;
  color: #707070;
  margin-top: 4px;
}

@media all and (min-width:0px) and (max-width:1280px){
  .card-main {
    position: relative;
    display: inline-block;
    margin-right: 20px;
    height: 227px;
  }
  .focus-ring {
    position: absolute;
    left: -5px;
    top: -4px;
    width: 250px;
    height: 233px;
    border: solid 3px #eeeeee;
    z-index: 5;
  }
  .card-text {
    padding: 12px 4px;
    display: inline-block;
    position: absolute;
    top: 137px;
    left: 0;
    width: 100%;
  }
  .cover-img {
    width: 244px;
    height: 137px;
    background-color: #2b2b2b;
  }
  .team-name {
    width: 347px;
    font-size: 16px;
    line-height: 24px;
    font-size: 16px;
    color: #a0a0a0;
  }
  .date {
    font-size: 14px;
    color: #707070;
    margin-top: 6px;
    line-height: 1;
  }
}
</style>